import { Box, Flex, Grid, Image, Text } from "@mantine/core";
import useStyles from "./style";
const DataAndSecuritySection = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.dataAndSecurity}>
      <Flex className="textContentWrapper">
        <Text className={classes.featureHdng}>Feature</Text>
        <Text className={classes.featureTitle}>Data and Security</Text>
        <Text className={classes.featureDiscription} ta="center">
          Security is our top priority. Ogiso is fully compliant with HIPAA
          regulations, ensuring that your clients data is secure and protected.
          Our advanced encryption protocols and regular updates safeguard your
          information against any potential threats.
        </Text>
      </Flex>
      <Box className="maxWidthBox">
        <Box className="col1">
          <Image src="/assets/images/data&securitySecImg1.png" mb={-45} />
          <Image src="/assets/images/data&securitySecImg2.png" mt={-45} />
        </Box>
        <Box className="col2">
          <Image src="/assets/images/data&securitySecImg3.png" />
        </Box>
        <Box className="col3">
          <Image src="/assets/images/data&securitySecImg4.png" />
        </Box>
      </Box>
    </Box>
  );
};

export default DataAndSecuritySection;
